import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { UserData, UserProfileModel } from "./type";

const initialState: UserProfileModel = {
  userData: {
    _id: "",
    countryCode: "",
    mobileNumber: "",
    created: 0, // timestamp in milliseconds
    lastLogin: 0, // timestamp in milliseconds
    dob: 0, // date of birth as a timestamp in milliseconds
    email: "",
    name: "",
    bannerUrl: "",
    walletVerifiedCredentials: {
      walletAddress: "",
    },
    totalXp: 0,
    totalRating: 0,
    totalReviews: 0,
    totalProductPurchased: 0,
    totalStrain: 0,
    totalManufactures: 0,
    profilePicture: "",
  },
};

const UserProfileSlice = createSlice({
  name: "UserProfile",
  initialState,
  reducers: {
    setUserData: (state: UserProfileModel, action: PayloadAction<UserData>) => {
      state.userData = action.payload;
    },
  },
});

export const { setUserData } = UserProfileSlice.actions;

export default UserProfileSlice.reducer;
